'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import Input from './Input';
import Verifier from 'ck-core/source/system/Verifier';
import propIsVerifierInstance from 'ck-core/source/functions/propIsVerifierInstance';
import InputLang from './InputLang.jsx';

export default class TextInput extends React.Component {
	constructor(props) {
		super(props);

		this.debouncedValidate = _.debounce(this.validate.bind(this), 200);
	}

	componentDidMount() {
		if (this.props.value || this.props.optional) {
			this.handleChange(this.props.value);
		}
	}

	async validate(value) {
		let isValid;
		let error;

		if (!value) {
			isValid = !!this.props.optional;

			if (!isValid) {
				error = InputLang.REQUIRED_FIELD_EMPTY;
			}
		} else if (!this.props.validate) {
			// Default validation for required input.
			isValid = !!this.props.value;
		} else if (Verifier.isInstance(this.props.validate)) {
			// this.props.validate is a verifier
			try {
				await this.props.validate.verify(value, true);

				isValid = true;
			} catch (err) {
				isValid = false;
				error = err.message;
			}
		} else {
			/* this.props.validate is assumed to be a function that returns whether the
			value is valid, and an error message if it is not */
			const result = await this.props.validate(value);
			isValid = _.get(result, 'valid', true);
			error = _.get(result, 'error');
		}

		if (this.props.onValidate) {
			this.props.onValidate(isValid, error);
		}
	}

	handleChange(value) {
		value = this.props.processValue ? this.props.processValue(value) : value;

		this.debouncedValidate(value);

		this.props.onChange.call(this, value);
	}

	render() {
		return (
			<Input {...this.props} className="TextInput">
				<input
					type={this.props.type}
					data-recording-ignore={this.props['data-recording-ignore']}
					autoComplete={this.props.autoComplete}
					placeholder={this.props.placeholder}
					name={this.props.name}
					value={this.props.value}
					min={this.props.minValue}
					step={this.props.stepValue}
					disabled={this.props.disabled}
					onBlur={this.props.onBlur}
					onChange={event => {
						const { target } = event;
						let { value } = target;

						this.handleChange(value);
					}}
				/>
			</Input>
		);
	}
}

TextInput.defaultProps = {
	value: '',
	type: 'text',
	optional: false
};

TextInput.propTypes = {
	name: PropTypes.string.isRequired,
	explanatoryText: PropTypes.string,
	value: PropTypes.string,
	disabled: PropTypes.bool,
	autoComplete: PropTypes.string,
	placeholder: PropTypes.string,
	type: PropTypes.oneOf(['text', 'tel', 'email', 'password', 'number']),
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	processValue: PropTypes.func,
	minValue: PropTypes.number,
	stepValue: PropTypes.number,
	onValidate: PropTypes.func,
	validate: PropTypes.oneOfType([PropTypes.func, propIsVerifierInstance]),
	'data-recording-ignore': PropTypes.string,
	optional: PropTypes.bool,
	noLabel: PropTypes.bool
};
